import axios from "axios";
import { api } from "./helper";
import store from "../../store/store"
import { v4 as uuidv4 } from 'uuid';

function prepareDataRequest(data) {
  return {
    RequestCorrelationId: uuidv4(),
    Data: data
  };
}

export function prepareRequest(data) {
  return {
    ...data,
    RequestCorrelationId: uuidv4()
  };
}

const client = axios.create({
    baseURL: api,
    withCredentials: false,
});

client.interceptors.request.use((config) => {
    config.headers.Authorization = "Bearer " + store.state.user.jwt;
    return config;
});

function CreateCalendarEvent(item) {
    return client.post("CalendarEvents/CreateCalendarEvent", prepareDataRequest(item));
}

function GetCalendarEvents(item) {
    return client.post(`CalendarEvents/GetCalendarEvents/`, prepareRequest(item));
}

function UpdateCalendarEvent(item) {
    return client.post("CalendarEvents/UpdateCalendarEvent", prepareDataRequest(item));
}

function DeleteCalendarEvent(id, uid) {
    var item = { id: id, commandUserId: uid};
    return client.post("CalendarEvents/DeleteCalendarEvent", prepareDataRequest(item));
}

export {
    CreateCalendarEvent,
    GetCalendarEvents,
    UpdateCalendarEvent,
    DeleteCalendarEvent
}